"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ua_parser_js_1 = require("ua-parser-js");
const parser = new ua_parser_js_1.UAParser();
parser.setUA(navigator.userAgent);
exports.default = parser.getResult();
//# sourceMappingURL=browserHelper.js.map